import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { UserProvider } from "./context/User/useUser";
import { NavBarProvider } from "./context/NavBar/useNavBar";
import { TabsProvider } from "./context/CustomTab/useTabs";
import { LicenseInfo } from '@mui/x-license';
import { SearchProvider } from "./context/Search/SearchContext";


const muiProKey = '8be565c1a943eaa7e3499f9565cc5647Tz0xMTg4ODIsRT0xNzg5MDg0Nzk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI=';
LicenseInfo.setLicenseKey(muiProKey);

const baseUrl = document.getElementsByTagName("base")[0].getAttribute("href");
const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <BrowserRouter basename={baseUrl}>
    <UserProvider>
      <NavBarProvider>
        <TabsProvider>
          <SearchProvider>
            <App />
          </SearchProvider>
        </TabsProvider>
      </NavBarProvider>
    </UserProvider>
  </BrowserRouter>
);
